/**
 * This is the twofa module configuration.
 * Do NOT configure routes in this file.
 * @memberOf twofa Module
 * @namespace twofa Config
 */

/**
 * @name config
 * @desc Configures the module.
 * @memberOf twofa Module.twofa Config
 * @ngInject
 */
var config = function () {
}

export default config;


// WEBPACK FOOTER //
// ./src/login/2fa/app/2fa.app.config.js